import theme from './theme'
import person from './person'
import text from './text'
import user from './user'
import google from './google'
import voicePreset from './voicePreset'

const merged = {...theme, ...person, ...text, ...user, ...google, ...voicePreset};

export default merged